import { FaQuestionCircle } from "react-icons/fa"
import Tooltip from "../ToolTip"

const TooltipInfoQuestion = ({ content }) => {
  return (
    <Tooltip content={content}>
      <div>
        <FaQuestionCircle className="hover:text-black transition-all duration-200 hover:cursor-pointer"/>
      </div>
    </Tooltip>
  )
}

export default TooltipInfoQuestion